import React from 'react';
import { EnelXGuiAtoms, EnelXGuiConsts, EnelXGuiUtils } from 'gui';
import styled, { useTheme } from 'styled-components';

const {
  MigrationIcon,
} = EnelXGuiAtoms;

const {
  COLOR_SECONDARY_BASE,
} = EnelXGuiConsts;

const {
  getDsyTokenValue,
} = EnelXGuiUtils;

export const Title = styled.p`
  padding:0;
  margin: ${(p) => p.margin ?? '0'};
  font-weight:700;
  font-size:1.5rem;
  color: ${(p) => p.theme.colors.accent.primary};
`;

export const dropdownTextStyle = {
  color: `${(p) => p.theme.colors.primary.black}`,
  fontStyle: 'normal',
  fontSize: '16px',
  cursor: 'pointer',
  margin: '5px 0 5px 0px',
};

export const CheckBoxWrapper = styled.div`
  border: solid 1px ${(p) => p.theme.colors.primary.grey};
  border-radius: 5px;
  padding: 15px;
  display: flex;
  margin-bottom: 5px;
`;

export const Dropdown = styled.div`
  width: 100%;
  height: auto;
  padding: 17px 20px;
  flex-direction: column;
  position: relative;
  top: 0;
  left: 0px;
  display: flex;
  max-height: 246px;
  overflow-y: auto;
`;

export const TextGrey = styled.span`
  color: ${(p) => p.theme.colors.primary.textGrey};
`;

export const ErrorLabel = styled.span`
  color: ${(p) => p.theme.colors.status.cherryRed};
`;

export const SelectGranularityWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
`;

export const PlusTwo = styled.div`
  background-color: ${(p) => p.theme.colors.custom.backgroundGrey};
  color: ${(p) => p.theme.colors.primary.white};
  border-radius: 5px;
  padding: 2px 5px;
  margin-left: 5px;
`;

export const plusValuesLabel = (exceededPrices) => {
  const theme = useTheme();
  return (
    <div style={{
      backgroundColor: theme.colors.custom.backgroundGrey,
      color: theme.colors.primary.white,
      borderRadius: '5px',
      padding: '2px 5px',
      marginLeft: '5px',
    }}
    >
      {`+${exceededPrices}`}

    </div>
  );
};

export const PlugIcon = styled.span`
  font-size: 24px;
  color: ${(p) => p.theme.colors.accent.primary};
  
  &:before {
    color: ${(p) => p.theme.colors.accent.primary};
  }
`;

export const PlugWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const ButtonWrapper = styled.button`
  height: 40px;
  display: flex;
  align-items: center;
  gap: 10px;
  align-items: center;
  padding: 5px 15px;
  border-radius: 100px;
  border: none;
  background: ${(p) => p.theme.colors.primary.white};
`;

export const QuestionWrapper = styled.div`
  min-height: ${(p) => (p.vertical ? '40px' : '75px')};
  min-height: ${(p) => p.isStart && 'initial'};
  width: ${(p) => `calc( (100% - ${8 * p.width - 1}px ) / ${p.width} )`};
  display: flex;
  flex-direction: ${(p) => (p.vertical ? 'row' : 'column')};
  align-items: ${(p) => p.vertical && 'center'};
  justify-content: ${(p) => (p.vertical ? 'space-between' : 'flex-end')};
  justify-content: 'flex-start';
  margin-bottom: ${(p) => p.vertical && '8px'};

  @media screen and (max-width: 900px) {
    width:${(p) => p.full && '100%'}
  }

  @media screen and (max-width: 768px) {
    width:100%
  }
`;

export const WidgetDisclaimer = ({ text }) => (
  <div className="flex items-center gap-3">
    <MigrationIcon
      color={getDsyTokenValue(COLOR_SECONDARY_BASE)}
      size="1em"
      name="info"
    />
    <p>{text}</p>
  </div>
);
